import React, { Component } from "react";
import "./News.css";
import classNames from "classnames";
import { connect } from "react-redux";
import { withRouter, NavLink } from "react-router-dom";
import { routeCodes } from "../../config/routes";

class Newscomp extends Component {
  scrollToTop() {
    window.scrollTo(0, 0);
  }

  renderNews(data) {
    return data.map((item, index) => {
      const NewsClasses = classNames("News", `News--${index + 1}`);
      return (
        <NavLink
          key={index}
          className={NewsClasses}
          onClick={() => this.scrollToTop()}
          to={{ pathname: routeCodes.PIECEOFNEWS, state: { data: item } }}
        >
          <div>
            <div className="News-imageWrapper">
              <img src={item.image} className="News-image" alt="News Latest" />
            </div>
            <div className="NewsContent">
              <div className="News-content--top">
                <h2 className="News-date">{item.date}</h2>
                <p className="News-title">{item.title}</p>
              </div>
              <div className="News-description">{item.description}</div>
            </div>
          </div>
        </NavLink>
      );
    });
  }

  render() {
    const { data } = this.props;
    return <div className="News-Main">{this.renderNews(data.news)}</div>;
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(Newscomp));



// WEBPACK FOOTER //
// ./src/components/News/index.js